import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  FormLayout,
  Heading,
  HorizontalRule,
  Paragraph,
  Section,
  IconStatusErrorOnlight,
  withTrackPage,
} from '@piggybank/core';

import { withAppContext } from '~/AppContext';

import styles from './error-page.module.css';
import { isButtonVisible } from './errorPageFunctions';

import nls from './nls/ErrorPage';
import { createTranslator } from '~/lib/nls-helper';

import getEnvironment from '~/lib/environment';

const environment = getEnvironment();
const NLS = createTranslator(nls);

const ErrorPage = ({ data }) => (
  <FormLayout>
    <Section>
      <div className={styles.error}>
        <IconStatusErrorOnlight width="2.5em" />
      </div>
      <Heading level={1}>{NLS`Something went wrong`}</Heading>
      <Paragraph lead>
        {NLS`We are currently having some technical difficulties. Please try again in a few minutes.`}
      </Paragraph>
      <HorizontalRule />
    </Section>
    <Section>
      <Heading accentBar level={2}>
        {NLS`More information`}
      </Heading>
      <Paragraph marginBottom={5}>
        {NLS`If this message appears while you were confirming your offer and you have doubts about whether the process was concluded, we recommend checking your email as you will receive the complete application notification.`}
      </Paragraph>
      <Paragraph marginBottom={5}>
        {NLS`If you do not receive an email, do not worry, your request was probably not completed. You can check it by visiting again the offers you have available to know if it is still showing.`}
      </Paragraph>
      <Paragraph marginBottom={5}>
        {NLS`The email to which you receive the confirmation of an offer is the one you have registered with Internet Banking or HSBC Mexico.`}
      </Paragraph>
    </Section>
    {isButtonVisible(data.initialData.globalData.ismobile) &&
      <Section>
        <Button elementType="a" href={environment.bankingDashboardUrl} target="_self">{NLS`Return to My accounts`}</Button>
      </Section>
    }
  </FormLayout>
);

ErrorPage.propTypes = {
  data: PropTypes.shape({
    initialData: PropTypes.shape({
      globalData: PropTypes.shape({
        ismobile: PropTypes.string,
      }),
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('errorPage', 'component')
)(ErrorPage);
